function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
/**
 * Multiplexer router for Sentry DSNs.
 * It will route the event to the correct DSN based on the app tag.
 * Use it in conjunction with Logger to route events to different Sentry projects.
 * @param multiplexerApps Object with app names as keys and DSNs as values
 * @param fallbackDsn DSN to be used when no app tag is found for the event
 */ export var multiplexerRouter = function(multiplexerApps, fallbackDsn) {
    return function(param) {
        var getEvent = param.getEvent;
        var event = getEvent();
        if (event) {
            var _event_tags = event.tags, tags = _event_tags === void 0 ? {} : _event_tags;
            for(var app in multiplexerApps){
                if (tags.app === app) {
                    return [
                        multiplexerApps[app]
                    ];
                }
            }
        }
        return [
            fallbackDsn
        ];
    };
};
/**
 * Adds merge request tags to a transaction event release value.
 * Use it in conjunction with Logger to add custom tags to Sentry performance.
 * In v3 apps, it is used to be able to see the merge request ID in Sentry when testing a MR Build.
 * @param map a map of remotes and their merge request IDs
 */ export var addMergeRequestToTransaction = function(map) {
    return function(event) {
        if (event.type === "transaction") {
            map.forEach(function(value, key) {
                console.debug("Sentry Logger [custom]: Set release tag for " + key + " with value " + value + " to event.");
                event.release = value;
            });
        }
        return event;
    };
};
/**
 * Sanitize transaction names for Sentry.
 * Use it to replace dynamic values in the pathname url with a static value to group transactions.
 * @param pathname the location.pathname value
 * @param transactionMap a record of transaction names as key and their regex as values to match the pathname
 */ export var sanitizeTransactions = function(pathname, transactionMap) {
    Object.entries(transactionMap).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), trasactionName = _param[0], regex = _param[1];
        if (regex.test(pathname)) {
            return trasactionName;
        }
    });
};
/**
 * Simple function to set the release tag in a Sentry event.
 * Use it in conjunction with Logger to set the release tag in Sentry events.
 * In v3 apps, it is used to set the release tag in Sentry Error events as the Shell release version is different than the subapp version.
 * @param sentryEvent
 */ export var setSubappRelease = function(sentryEvent) {
    var _sentryEvent_tags, _sentryEvent;
    if ((_sentryEvent = sentryEvent) == null ? void 0 : (_sentryEvent_tags = _sentryEvent.tags) == null ? void 0 : _sentryEvent_tags.release) {
        sentryEvent.release = sentryEvent.tags.release.toString();
    }
};
